import { useEffect, useState } from "react";
import { adminApi } from "@/components/admin/api";
import JourneyCalendar from "@/components/JourneyCalendar";

const SlotPicker = ({ date, time, onDate, onTime, testPrefix }) => {
  const [schedule, setSchedule] = useState(null);
  const [slots, setSlots] = useState(null);

  useEffect(() => {
    adminApi.get("/journey/schedule").then((res) => setSchedule(res.data)).catch(() => setSchedule(null));
  }, []);

  const pickDate = (d) => {
    onDate(d);
    onTime("");
    setSlots(null);
    adminApi
      .get("/journey/availability", { params: { date: d } })
      .then((res) => setSlots(res.data.times))
      .catch(() => setSlots([]));
  };

  return (
    <div data-testid={`${testPrefix}-slot-picker`}>
      <JourneyCalendar schedule={schedule} selected={date} onSelect={pickDate} />
      {date && (
        <div className="mt-4">
          {!slots ? (
            <div className="grid grid-cols-4 gap-2">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="h-9 animate-pulse rounded-full bg-cream" />
              ))}
            </div>
          ) : slots.filter((s) => s.available).length === 0 ? (
            <p className="text-xs text-ink/50">Sem horários livres nesta data.</p>
          ) : (
            <div className="flex flex-wrap gap-2">
              {slots
                .filter((s) => s.available)
                .map((s) => (
                  <button
                    key={s.time}
                    type="button"
                    data-testid={`${testPrefix}-hora-${s.time.replace(":", "")}`}
                    onClick={() => onTime(s.time)}
                    className={`rounded-full border px-3.5 py-1.5 text-xs transition-colors ${
                      time === s.time ? "border-raiz-800 bg-raiz-800 text-paper" : "border-raiz-800/25 text-raiz-900 hover:border-raiz-800"
                    }`}
                  >
                    {s.time}
                  </button>
                ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SlotPicker;
